<template>
  <div class="flex flex-col items-center justify-center p-5 pb-20">
    <div class="flex justify-center items-center bg-[#2185790F] rounded-full h-12 w-12">
      <SearchIcon :custom-style="`text-[#218579] size-4`" />
    </div>
    <p class="text-md md:text-base lg:text-[18px] font-semibold text-[#606A79] text-center mt-4 font-inter">
      {{ title }}
    </p>
    <p class="text-sm md:text-base lg:text-[17px] text-center text-[rgba(98,114,133,0.80)] leading-[20px] mt-2 font-inter">
      {{ subtitle }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',

  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
}
</script>
